import { render, staticRenderFns } from "./HsaSubMenu.vue?vue&type=template&id=940bfdee&scoped=true"
import script from "./HsaSubMenu.vue?vue&type=script&lang=ts"
export * from "./HsaSubMenu.vue?vue&type=script&lang=ts"
import style0 from "./HsaSubMenu.vue?vue&type=style&index=0&id=940bfdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940bfdee",
  null
  
)

export default component.exports